// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1KNQh","choiceBoxes":"toolbarselects_choiceBoxes__1vO8p","simpleField":"toolbarselects_simpleField__1B95I"};